export const STATUS_ITEMS = [
    { name: 'Success', label: 'Success', value: 'Success' },
    { name: 'Failed', label: 'Failed', value: 'Failed' },
]